import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import ToggleSearchButtonComponent from '../buttons/toggle-search-button';

import { Direction } from './types';

type PlaceholderProps = {
  direction: Direction;
};

export const Lines = styled.div`
  display: flex;
  align-items: center;
`;

export const Placeholder = styled.div<PlaceholderProps>`
  display: flex;

  ${props =>
    props.direction === Direction.COLUMN &&
    css`
      flex-direction: column;

      ${Lines} {
        flex-direction: column;
      }
    `}
`;

type ItemProps = {
  width: number;
  height: number;
};

export const Item = styled.div<ItemProps>`
  background-color: ${p => p.theme.placeholders.fg};
  border-radius: 5px;
  opacity: 0.25;

  &:not(:first-child) {
    margin-top: ${layout.measurements.spacing100};
  }

  ${p =>
    css`
      max-width: ${p.width}px;
      width: 100%;
      height: ${p.height}px;
    `}
`;

export const Icon = styled.div`
  margin-right: ${layout.measurements.spacing050};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  background: transparent;
  padding: 0;
  border-radius: 0;
`;

export const Image = styled.img`
  max-width: 40px;
  max-height: 40px;
  mix-blend-mode: multiply;
`;

export const ToggleSearchButton = styled(ToggleSearchButtonComponent)`
  margin-top: ${layout.measurements.spacing100};
`;
